import type { LogEntry } from "@/components/catalog/MiniLogPreview";

/**
 * Convert a subscription update payload to a LogEntry. One function per file (single method per file).
 */
export function subscriptionUpdateToLogEntry(
  update: {
    status?: string | null;
    progress?: number | null;
    payload?: unknown;
  },
  logId: number,
): LogEntry {
  const timestamp = new Date().toISOString();
  const status = (update.status ?? "").toUpperCase();
  let level: LogEntry["level"] = "info";
  if (["COMPLETED", "DONE", "REVIEW_READY"].includes(status)) level = "success";
  else if (["FAILED", "ERROR", "CANCELLED"].includes(status)) level = "error";
  else if (status === "RUNNING" || status === "IN_PROGRESS") level = "info";

  const payload = update.payload as { message?: string } | undefined;
  const message =
    payload?.message ??
    (update.progress != null
      ? `${update.status ?? "Progress"} — ${Math.round(Number(update.progress))}%`
      : (update.status ?? "Update"));

  return { id: logId, timestamp, level, message };
}
